type OS = 'mac' | 'windows' | 'linux' | 'ios' | 'android';

const getOS = (): OS | null => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i;
    const windowsPlatforms = /(win32|win64|windows|wince)/i;
    const iosPlatforms = /(iphone|ipad|ipod)/i;

    if (macosPlatforms.test(userAgent)) {
        return 'mac';
    }
    if (iosPlatforms.test(userAgent)) {
        return 'ios';
    }
    if (windowsPlatforms.test(userAgent)) {
        return 'windows';
    }
    if (/android/.test(userAgent)) {
        return 'android';
    }
    if (/linux/.test(userAgent)) {
        return 'linux';
    }

    return null;
};

export { getOS };
export type { OS };
